export default {"src":"/_next/static/media/subSol2.f53dd0c6.svg","height":56,"width":52};